export default "__VITE_ASSET__Cc0356jM__"